import React from "react";

export const LogoMark = ({ size = 40 }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <rect width="64" height="64" rx="14" fill="#0A192F" />
    <path d="M14 34 L32 18 L50 34" stroke="#F8F9FA" strokeWidth="4.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M20 32 V48 H44 V32" stroke="#F8F9FA" strokeWidth="4.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M32 44.5 C27.5 41 26 38.4 26 36.2 C26 34 27.6 32.5 29.6 32.5 C30.8 32.5 31.6 33.1 32 33.9 C32.4 33.1 33.2 32.5 34.4 32.5 C36.4 32.5 38 34 38 36.2 C38 38.4 36.5 41 32 44.5 Z"
      fill="#10B981"
    />
  </svg>
);

export const BrandLockup = ({ testid = "brand-logo-link" }) => (
  <a href="#top" data-testid={testid} className="flex items-center gap-3 group">
    <LogoMark size={42} />
    <span className="leading-tight">
      <span className="block font-display font-extrabold text-[#0A192F] text-xl sm:text-2xl tracking-tight group-hover:text-[#10B981] transition-colors duration-300">
        Casamatch
      </span>
      <span className="block text-[11px] font-semibold tracking-wide text-slate-500">
        La casa cerca te! · casamatch.org
      </span>
    </span>
  </a>
);
